import React, { FC } from 'react';

import { HorizontalLineProps } from './models';

import './HorizontalLine.scss';

const HorizontalLine: FC<HorizontalLineProps> = () => <hr className="horizontal-line" />;

export default HorizontalLine;
